module.exports = __webpack_public_path__ + "static/media/user-experience.a0c51652.svg";